module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "formData"
  }, [_c('el-form', {
    ref: "sForm",
    staticClass: "all-form",
    staticStyle: {
      "padding-right": "0"
    },
    attrs: {
      "model": _vm.sForm,
      "label-width": "100px",
      "size": "small"
    }
  }, [_vm._l((_vm.formColumnList.filter(function (item) {
    if (_vm.orderEdit) {
      return item.fieldName != 'labelPath' && item.fieldName != 'cId'
    } else {
      return item.fieldName != 'labelPath'
    }
  })), function(item, index) {
    return _c('el-form-item', {
      key: index,
      staticClass: "mb15",
      style: (_vm.getStyle(item)),
      attrs: {
        "prop": item.fieldName,
        "rules": item.isRequired == 1 ? _vm.rulesFunc(item) : [{
          required: false
        }]
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_vm._v(_vm._s(item.fieldCnName))]), _vm._v(" "), (item.inputType === 'datetimerange') ? _c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
        "type": "datetimerange",
        "range-separator": "~",
        "start-placeholder": _vm.Language('开始日期'),
        "end-placeholder": _vm.Language('结束日期'),
        "value-format": "yyyy-MM-dd HH:mm:ss"
      },
      on: {
        "change": function($event) {
          _vm.sForm[item.fieldName] = _vm.datetimerangeObj[item.fieldName] ? _vm.datetimerangeObj[item.fieldName][0] : ''
        }
      },
      model: {
        value: (_vm.datetimerangeObj[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.datetimerangeObj, item.fieldName, $$v)
        },
        expression: "datetimerangeObj[item.fieldName]"
      }
    }) : (item.inputType == 'date') ? _c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
        "type": "date",
        "placeholder": _vm.Language('请选择') + item.fieldCnName
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType == 'time') ? _c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
        "type": "time",
        "placeholder": _vm.Language('请选择') + item.fieldCnName
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType == 'datetime') ? _c('el-date-picker', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return',
        "type": "datetime",
        "placeholder": _vm.Language('请选择') + item.fieldCnName
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.fieldName === 'isOverTime' || item.fieldName === 'isWheelOverTime' || item.fieldName === 'isTipsCus' ||
      item.fieldName === 'isVisit' || item.fieldName === 'isBeVisit' || item.fieldName === 'isSolved' || item.fieldName === 'isSat') ? _c('el-switch', {
      attrs: {
        "active-value": '1',
        "inactive-value": '0',
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType == 'radio' || item.inputType == 'checkbox') ? _c('RadioCheckBox', {
      ref: item.fieldName,
      refInFor: true,
      attrs: {
        "dataOrigin": item.dataOrigin,
        "inputType": item.inputType,
        "fieldName": item.fieldName,
        "editType": _vm.editType,
        "filterData": _vm.filterData[item.dataOrigin]
      }
    }) : (item.inputType === 'select' || item.inputType == 'personnelSelect') ? _c('SelectList', {
      ref: item.fieldName,
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholderLoad": item.fieldCnName,
        "dataMultiple": item.selectType,
        "dataOrigin": item.dataOrigin,
        "inputType": item.inputType,
        "fieldName": item.fieldName,
        "editType": _vm.editType,
        "filterData": _vm.filterData[item.dataOrigin]
      },
      on: {
        "selectChange": _vm.selectChange,
        "changeOrgFn": _vm.changeOrgFn
      }
    }) : (item.inputType === 'cascader') ? _c('CascaderList', {
      ref: item.fieldName,
      refInFor: true,
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "checkStrictly": item.cascadeType == 1 ? true : false,
        "placeholderLoad": item.fieldCnName,
        "dataOrigin": item.dataOrigin,
        "editType": _vm.editType
      }
    }) : (item.inputType === 'textarea') ? _c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "type": "textarea",
        "placeholder": _vm.Language('请输入') + item.fieldCnName,
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType === 'number') ? _c('el-input-number', {
      staticStyle: {
        "width": "150px"
      },
      attrs: {
        "controls-position": "right",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, $$v)
        },
        expression: "sForm[item.fieldName]"
      }
    }) : (item.inputType === 'departmentSelect') ? _c('DepartPersonSelect', {
      ref: item.fieldName,
      refInFor: true,
      attrs: {
        "editType": _vm.editType
      }
    }) : (item.fieldName == 'labelData') ? _c('div', [(_vm.cusLabPath && _vm.cusLabPath.length) ? _c('div', {
      ref: item.fieldName,
      refInFor: true,
      staticClass: "label-list"
    }, [(_vm.editType != 'examine' && _vm.editType != 'info' && _vm.editType != 'return') ? _c('span', _vm._l((_vm.cusLabPath), function(item, index) {
      return _c('el-tag', {
        key: index,
        staticStyle: {
          "margin-right": "5px"
        },
        attrs: {
          "type": "success",
          "size": "small",
          "closable": ""
        },
        on: {
          "close": function($event) {
            return _vm.removeCusLab(item, index)
          }
        }
      }, [_vm._v(_vm._s(item.LabPath))])
    }), 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "text",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      on: {
        "click": function($event) {
          _vm.cusLabVisible = true
        }
      }
    }, [_vm._v(_vm._s(_vm.cusLabPath.length ? '继续选择' : '选择标签'))])], 1) : (item.fieldName == 'telData') ? _c('div', [(_vm.GLOBAL.power.is_1030 || _vm.GLOBAL.power.is_1031) ? _c('el-input', {
      staticClass: "input-with-select addData",
      style: ({
        width: _vm.orderEdit ? 'calc(100% - 55px)' : '100%'
      }),
      attrs: {
        "clearable": "",
        "placeholder": _vm.Language('请输入') + item.fieldCnName,
        "disabled": ""
      },
      model: {
        value: (_vm.sForm[item.fieldName + '-re']),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName + '-re', (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "sForm[item.fieldName+'-re']"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "icon": "iconfont icon-ai57-btn",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      on: {
        "click": function($event) {
          return _vm.handleAddFn(item.fieldName)
        }
      },
      slot: "append"
    }, [_vm._v(_vm._s(_vm.Language('添加')))])], 1) : _c('el-input', {
      staticClass: "input-with-select addData",
      style: ({
        width: _vm.orderEdit ? 'calc(100% - 55px)' : '100%'
      }),
      attrs: {
        "clearable": "",
        "placeholder": _vm.Language('请输入') + item.fieldCnName,
        "disabled": ""
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "sForm[item.fieldName]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "icon": "iconfont icon-ai57-btn",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      on: {
        "click": function($event) {
          return _vm.handleAddFn(item.fieldName)
        }
      },
      slot: "append"
    }, [_vm._v(_vm._s(_vm.Language('添加')))])], 1), _vm._v(" "), (item.fieldName == 'telData' && _vm.orderEdit) ? _c('i', {
      staticClass: "iconfont iconhuifang font-16 cur-p blue ml-5",
      on: {
        "click": function($event) {
          return _vm.handleMsgFn(item.fieldName, 1)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.fieldName == 'telData' && _vm.orderEdit) ? _c('i', {
      staticClass: "iconfont icona-008duanxin font-20 cur-p blue",
      on: {
        "click": function($event) {
          return _vm.handleMsgFn(item.fieldName, 2)
        }
      }
    }) : _vm._e()], 1) : (item.fieldName == 'emailData') ? _c('div', [_c('el-input', {
      staticClass: "input-with-select addData",
      style: ({
        width: _vm.orderEdit ? 'calc(100% - 55px)' : '100%'
      }),
      attrs: {
        "clearable": "",
        "placeholder": _vm.Language('请输入') + item.fieldCnName,
        "disabled": ""
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "sForm[item.fieldName]"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "icon": "iconfont icon-ai57-btn",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      on: {
        "click": function($event) {
          return _vm.handleAddFn(item.fieldName)
        }
      },
      slot: "append"
    }, [_vm._v(_vm._s(_vm.Language('添加')))])], 1), _vm._v(" "), (item.fieldName == 'emailData' && _vm.orderEdit) ? _c('i', {
      staticClass: "iconfont icona-009youjian font-20 cur-p blue ml-5",
      on: {
        "click": function($event) {
          return _vm.handleMsgFn(item.fieldName, 3)
        }
      }
    }) : _vm._e()], 1) : _c('div', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('el-dropdown', {
      staticClass: "hotlineCusname",
      on: {
        "command": _vm.handleCommand
      }
    }, [_c('span', {
      staticClass: "el-dropdown-link"
    }, [((item.fieldName == 'cusName' && _vm.editType == 'hotline' && _vm.hotlineCusList.length)) ? _c('i', {
      staticClass: "el-icon-s-custom el-input__icon font-22 cur-p blue",
      attrs: {
        "slot": "reference",
        "title": "选择客户"
      },
      slot: "reference"
    }) : _vm._e()]), _vm._v(" "), _c('el-dropdown-menu', {
      attrs: {
        "slot": "dropdown"
      },
      slot: "dropdown"
    }, _vm._l((_vm.hotlineCusList), function(item, index) {
      return _c('el-dropdown-item', {
        key: index,
        attrs: {
          "icon": "el-icon-user-solid",
          "command": item
        }
      }, [_vm._v(_vm._s(item.cusName))])
    }), 1)], 1), _vm._v(" "), _c('el-input', {
      staticClass: "input-with-select",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": _vm.Language('请输入') + item.fieldCnName,
        "clearable": _vm.editType != 'hotline',
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      model: {
        value: (_vm.sForm[item.fieldName]),
        callback: function($$v) {
          _vm.$set(_vm.sForm, item.fieldName, (typeof $$v === 'string' ? $$v.trim() : $$v))
        },
        expression: "sForm[item.fieldName]"
      }
    }, [(((item.fieldName == 'cusName' || item.fieldName == 'name') && _vm.orderEdit)) ? _c('el-button', {
      attrs: {
        "slot": "append",
        "icon": "el-icon-search",
        "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
      },
      on: {
        "click": function($event) {
          return _vm.openCusSelectFn(item.fieldName)
        }
      },
      slot: "append"
    }) : _vm._e()], 1)], 1)], 1)
  }), _vm._v(" "), (_vm.showSubButton) ? _c('el-row', {
    staticClass: "submitButton"
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.editType == 'examine' || _vm.editType == 'info' || _vm.editType == 'return'
    },
    on: {
      "click": _vm.saveFn
    }
  }, [_vm._v(_vm._s(_vm.Language('提 交')))])], 1)], 1) : _vm._e()], 2), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "addOperator center-dialog Operator-add new-dialog-box",
      "title": _vm.operateTitle,
      "width": "25%",
      "visible": _vm.detDialog,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.detDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "detInfoList"
  }, [_c('el-form', {
    ref: "detForm",
    staticClass: "padding10-15",
    attrs: {
      "model": _vm.detForm
    }
  }, [_c('el-table', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "data": _vm.detForm.dataList
    }
  }, [(_vm.detType == 'telData') ? _c('el-table-column', {
    attrs: {
      "prop": "data",
      "label": _vm.Language('电话')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return (_vm.detType == 'telData') ? [(_vm.GLOBAL.power.is_1031) ? _c('el-form-item', {
          attrs: {
            "prop": "datare",
            "rules": _vm.rulesFunc2(scope.row)
          }
        }, [_c('el-input', {
          staticStyle: {
            "width": "220px"
          },
          attrs: {
            "disabled": _vm.isCallout
          },
          model: {
            value: (scope.row.datare),
            callback: function($$v) {
              _vm.$set(scope.row, "datare", (typeof $$v === 'string' ? $$v.trim() : $$v))
            },
            expression: "scope.row.datare"
          }
        })], 1) : _c('el-form-item', {
          attrs: {
            "prop": "data",
            "rules": _vm.rulesFunc2(scope.row)
          }
        }, [_c('el-input', {
          staticStyle: {
            "width": "220px"
          },
          attrs: {
            "disabled": _vm.isCallout
          },
          model: {
            value: (scope.row.data),
            callback: function($$v) {
              _vm.$set(scope.row, "data", (typeof $$v === 'string' ? $$v.trim() : $$v))
            },
            expression: "scope.row.data"
          }
        })], 1)] : undefined
      }
    }], null, true)
  }) : _vm._e(), _vm._v(" "), (_vm.detType == 'emailData') ? _c('el-table-column', {
    attrs: {
      "prop": "data",
      "label": _vm.Language('邮箱')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          attrs: {
            "prop": "data",
            "rules": _vm.rulesFunc2(scope.row)
          }
        }, [_c('el-input', {
          staticStyle: {
            "width": "220px"
          },
          attrs: {
            "disabled": _vm.isCallout
          },
          model: {
            value: (scope.row.data),
            callback: function($$v) {
              _vm.$set(scope.row, "data", (typeof $$v === 'string' ? $$v.trim() : $$v))
            },
            expression: "scope.row.data"
          }
        })], 1)]
      }
    }], null, false, 4236203818)
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.Language('操作'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "placement": "top",
            "enterable": false
          }
        }, [_c('div', {
          attrs: {
            "slot": "content"
          },
          slot: "content"
        }, [_vm._v(_vm._s(_vm.Language(!_vm.isCallout ? '删除' : '外呼')))]), _vm._v(" "), (!_vm.isCallout) ? _c('i', {
          staticClass: "iconfont icon-shanchu table-icon-btn",
          staticStyle: {
            "color": "red"
          },
          on: {
            "click": function($event) {
              return _vm.delEntityItemFn(scope.$index, scope.row)
            }
          }
        }) : _c('i', {
          staticClass: "iconfont iconhuifang font-16 cur-p blue ml-5",
          on: {
            "click": function($event) {
              return _vm.handleCalloutFn(scope.row)
            }
          }
        })])]
      }
    }])
  })], 1), _vm._v(" "), (!_vm.isCallout) ? _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "text",
      "icon": "el-icon-plus"
    },
    on: {
      "click": _vm.addEntityItemFn
    }
  }, [_vm._v(_vm._s(_vm.operateTitle))]) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.isCallout) ? _c('div', {
    staticClass: "diglog-bom-box"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "disabled": !_vm.isPassRules
    },
    on: {
      "click": _vm.handleSubmitFn
    }
  }, [_vm._v(_vm._s(_vm.Language('确定')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.detDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('取消')))])], 1) : _vm._e()]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "addOperator center-dialog Operator-add new-dialog-box",
      "title": _vm.Language('客户'),
      "width": "60%",
      "visible": _vm.customerDialog,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.customerDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "searchForm"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.searchForm,
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('客户名称'),
      "prop": "cusName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "clearable": "",
      "maxlength": "20",
      "placeholder": _vm.Language('客户名称')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.customerGetListFn(1)
      }
    },
    model: {
      value: (_vm.searchForm.cusName),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "cusName", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.cusName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.Language('联系方式')
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "placeholder": _vm.Language('渠道类型'),
      "clearable": ""
    },
    model: {
      value: (_vm.searchForm.contactType),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "contactType", $$v)
      },
      expression: "searchForm.contactType"
    }
  }, _vm._l((_vm.filterData['orderOriginType']), function(item) {
    return _c('el-option', {
      key: item.dictCode,
      attrs: {
        "label": item.dictName,
        "value": item.dictCode
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.Language('联系方式')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.customerGetListFn(1)
      }
    },
    model: {
      value: (_vm.searchForm.contactVal),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "contactVal", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.contactVal"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "15px"
    }
  }, [_c('el-button', {
    staticClass: "queryBtn",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.customerGetListFn(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('查询')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.cusList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "cusName",
      "label": _vm.Language('客户名称'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sex",
      "label": _vm.Language('客户性别'),
      "show-overflow-tooltip": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.Language(scope.row.sex == 1 ? '男' : '女')))])]
      }
    }])
  }), _vm._v(" "), (!_vm.GLOBAL.power.is_1030) ? _c('el-table-column', {
    attrs: {
      "prop": "telData",
      "label": _vm.Language('客户电话'),
      "show-overflow-tooltip": "",
      "formatter": _vm.formatterPhone2
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "emailData",
      "label": _vm.Language('客户邮箱'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": _vm.Language('客户描述'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.Language('操作'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "padding": "0"
          },
          attrs: {
            "type": "text",
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.handleSelectCus(scope.row, 1)
            }
          }
        }, [_vm._v("选择")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total > 0) ? _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "current-page": _vm.pageNo,
      "page-sizes": [10, 20, 30, 40, 50],
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "addOperator center-dialog Operator-add new-dialog-box",
      "title": _vm.Language('公司'),
      "width": "60%",
      "visible": _vm.cusCompanyDialog,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.cusCompanyDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "searchForm"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.searchForm,
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.Language('公司名称'),
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "clearable": "",
      "maxlength": "20"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cusCompanyGetListFn(1)
      }
    },
    model: {
      value: (_vm.searchForm.name),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "searchForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "15px"
    }
  }, [_c('el-button', {
    staticClass: "queryBtn",
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.cusCompanyGetListFn(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.Language('查询')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.cusCompanyList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.Language('公司名称'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": _vm.Language('公司描述'),
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createOper",
      "label": _vm.Language('创建人')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.formatColumn('createOper', scope.row)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.Language('操作'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          staticStyle: {
            "padding": "0"
          },
          attrs: {
            "type": "text",
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              return _vm.handleSelectCus(scope.row, 2)
            }
          }
        }, [_vm._v("选择")])]
      }
    }])
  })], 1), _vm._v(" "), (_vm.total > 0) ? _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "current-page": _vm.pageNo,
      "page-sizes": [10, 20, 30, 40, 50],
      "page-size": _vm.pageSize,
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "cusLabDialog",
    attrs: {
      "title": _vm.Language('客户标签'),
      "width": "60%",
      "visible": _vm.cusLabVisible,
      "close-on-press-escape": false,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    on: {
      "update:visible": function($event) {
        _vm.cusLabVisible = $event
      }
    }
  }, [(_vm.cusLabVisible) ? _c('CusLable', {
    attrs: {
      "cusLabPath": _vm.cusLabPath
    },
    on: {
      "submitLabFn": _vm.submitLabFn
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-39dc1124","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/Sass/components/FormData.vue
// module id = 1327
// module chunks = 5